import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Bouton from "../../../../../components/Button/Bouton";
import Chip from "../../../../../components/Chip";
import {
  DossierLocationCompositionLocationEnum,
  DossierParticulierDetail,
  Partenaire,
} from "../../../../../services/Api/swagger";
import InfoCandidat from "./InfoCandidat";
import styles from "../styles";

interface Props {
  data?: DossierParticulierDetail[];
  typeDossier?: DossierLocationCompositionLocationEnum;
  cantModify: boolean;
  addColoc(ref: string): void;
  addLocataire(ref: string): void;
  selectedDossier?: string;
  setSelectedPerson(ref: string): void;
  statutDossier?: string;
  partenaire?: Partenaire;
  isCandidatLocataire?: boolean;
}
function InfoCandidats({
  data,
  typeDossier,
  cantModify,
  statutDossier,
  partenaire,
  addColoc,
  addLocataire,
  setSelectedPerson,
  selectedDossier,
  isCandidatLocataire,
}: Props) {
  const defaultPersonSelected = data && data[0] && data[0].reference;

  const [personSelectedId, setIdPersonSelected] = useState(
    defaultPersonSelected || ""
  );

  useEffect(() => {
    if (defaultPersonSelected) {
      setSelectedPerson(defaultPersonSelected);
    }
  }, [defaultPersonSelected]);

  const handleSelectPerson = (id: string) => {
    setIdPersonSelected(id);
    setSelectedPerson(id);
  };

  // const addColoc = () => {
  //   if (this.props.addColoc && this.props.selectedDossier) {
  //     this.props.addColoc(this.props.selectedDossier);
  //   }
  // };

  // addLocataire = () => {
  //   if (this.props.addLocataire && this.props.selectedDossier) {
  //     this.props.addLocataire(this.props.selectedDossier);
  //   }
  // };
  let personSelected;
  if (data && data.length > 0) {
    personSelected = personSelectedId
      ? data.find((person) => person.reference === personSelectedId)
      : data[0];
  }
  const isConjoint =
    (personSelected &&
      typeDossier === "COUPLE" &&
      !personSelected.principal &&
      personSelected.typeCompte === "LOCATAIRE") ||
    false;
  const canAddColocPart =
    !partenaire ||
    (statutDossier !== "EN_TRANSFERT" &&
      statutDossier !== "VALIDE" &&
      statutDossier !== "VALIDE_NON_AGREE" &&
      statutDossier !== "VALIDE_AGREE_DIFFERE" &&
      statutDossier !== "VALIDE_AGREE");

  return (
    <Grid
      container
      alignItems="flex-start"
      justifyContent="flex-start"
      className={"candidats"}
    >
      {data && data.length === 0 && statutDossier !== "NON_VALIDE" && (
        <Grid container className={"ajoutColoc"}>
          <Bouton
            label="+ Ajouter un locataire"
            color="secondary"
            variant="contained"
            size="small"
            onClick={() => selectedDossier && addLocataire(selectedDossier)}
          />
        </Grid>
      )}
      {data &&
      data.length === 1 &&
      typeDossier === "SEUL" &&
      statutDossier !== "NON_VALIDE" ? (
        <>
          {canAddColocPart && (
            <Grid container justifyContent="flex-end" className={"ajoutColoc"}>
              <Bouton
                label="+ Ajouter un(e) colocataire"
                color="secondary"
                variant="contained"
                size="small"
                onClick={() => selectedDossier && addColoc(selectedDossier)}
              />
            </Grid>
          )}
          <InfoCandidat
            isConjoint={false}
            personne={data[0]}
            cantModify={cantModify}
            statutDossier={statutDossier}
            refDossier={selectedDossier}
            allEtudiant={data
              .filter((d) => d.typeCompte === "LOCATAIRE")
              .every((e) => e.codeStatutProfessionnel === "ETU")}
            canAddGarant={statutDossier !== "EN_TRANSFERT"}
            isCandidatLocataire={isCandidatLocataire}
          />
        </>
      ) : (
        <>
          <Grid container wrap="nowrap" alignItems="flex-start">
            <div className={"contentChips"}>
              {/* Selection de la personne */}
              {data &&
                data.map((personne, i) => {
                  let nomCandidat =
                    "Candidat(e)" + " " + personne.prenom + " " + personne.nom;
                  if (
                    typeDossier === "COLOCATION" &&
                    personne.typeCompte !== "GARANT"
                  ) {
                    nomCandidat =
                      "Locataire" + " " + personne.prenom + " " + personne.nom;
                  } else if (personne.typeCompte === "GARANT") {
                    const locataireConcerne = data.find(
                      (dos) => dos.reference === personne.refDossierLocataire
                    );
                    nomCandidat = locataireConcerne
                      ? "Garant de " +
                        locataireConcerne.prenom +
                        " " +
                        locataireConcerne.nom
                      : "";
                  } else if (typeDossier === "COUPLE" && !personne.principal) {
                    nomCandidat =
                      "Conjoint(e)" +
                      " " +
                      personne.prenom +
                      " " +
                      personne.nom;
                  }
                  return (
                    <Chip
                      active={personSelectedId === personne.reference}
                      key={i}
                      invalid={
                        personne.statut === "BLOQUE" ||
                        personne.statut === "NON_VALIDE" ||
                        personne.statut === "INCOMPLET" ||
                        personne.statut === "EN_TRANSFERT"
                      }
                      valid={personne.statut === "VALIDE"}
                      onClick={handleSelectPerson}
                      label={nomCandidat}
                      id={personne.reference || ""}
                    />
                  );
                })}
            </div>
            {statutDossier !== "NON_VALIDE" &&
              typeDossier &&
              canAddColocPart &&
              (typeDossier === "COLOCATION" || typeDossier === "SEUL") &&
              data &&
              data.filter((d) => d.typeCompte !== "GARANT").length < 5 && (
                <Bouton
                  label="+ Ajouter un(e) colocataire"
                  color="secondary"
                  variant="contained"
                  size="small"
                  onClick={() => selectedDossier && addColoc(selectedDossier)}
                />
              )}
          </Grid>
          <InfoCandidat
            isConjoint={isConjoint}
            personne={personSelected}
            cantModify={cantModify || statutDossier === "VALIDE"}
            statutDossier={statutDossier}
            isCandidatLocataire={isCandidatLocataire}
            refDossier={selectedDossier}
            hasGarant={
              data &&
              data.find((d) => d.refDossierLocataire === personSelectedId)
                ? true
                : false
            }
            allEtudiant={
              data &&
              data
                .filter((d) => d.typeCompte === "LOCATAIRE")
                .every(
                  (e) =>
                    e.codeStatutProfessionnel === "ETU" ||
                    !e.codeStatutProfessionnel
                )
            }
            canAddGarant={statutDossier !== "EN_TRANSFERT"}
          />
        </>
      )}
    </Grid>
  );
}

export default InfoCandidats;
